import { render, staticRenderFns } from "./BindAccount.vue?vue&type=template&id=8fac28f8&scoped=true"
import script from "./BindAccount.vue?vue&type=script&lang=js"
export * from "./BindAccount.vue?vue&type=script&lang=js"
import style0 from "./BindAccount.vue?vue&type=style&index=0&id=8fac28f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fac28f8",
  null
  
)

export default component.exports